var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 27,
    viewBox: "0 0 16 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.104 13.158c0-.472.18-.943.539-1.303L11.958.541a1.843 1.843 0 112.606 2.606L4.552 13.157 14.564 23.17a1.843 1.843 0 11-2.607 2.606L.643 14.461c-.36-.36-.54-.832-.54-1.303z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAxNiAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMTAzNTc2IDEzLjE1NzlDMC4xMDM1NzYgMTIuNjg2MyAwLjI4MzY0NyAxMi4yMTQ4IDAuNjQzMDMxIDExLjg1NTJMMTEuOTU3OCAwLjU0MDU2N0MxMi42Nzc1IC0wLjE3OTE5MiAxMy44NDQ1IC0wLjE3OTE5MiAxNC41NjQgMC41NDA1NjdDMTUuMjgzNCAxLjI2MDAzIDE1LjI4MzQgMi40MjY3NyAxNC41NjQgMy4xNDY1OEw0LjU1MjA2IDEzLjE1NzlMMTQuNTYzNiAyMy4xNjkzQzE1LjI4MzEgMjMuODg5MSAxNS4yODMxIDI1LjA1NTcgMTQuNTYzNiAyNS43NzUxQzEzLjg0NDIgMjYuNDk1MiAxMi42NzcyIDI2LjQ5NTIgMTEuOTU3NCAyNS43NzUxTDAuNjQyNjgxIDE0LjQ2MDZDMC4yODMyMzggMTQuMTAwOSAwLjEwMzU3NiAxMy42Mjk0IDAuMTAzNTc2IDEzLjE1NzlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgArrowLeft as ReactComponent };